module.exports = __webpack_public_path__ + "img/sizeguide__measurements.3b995b7.jpg";